import React, { Component } from "react";
import platform from "Pub/js/platform";
import { handleHotKey } from "./methods";
const { NCModal } = platform.base;
// 快捷键NC弹窗
class HotKeyNCModal extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        document.addEventListener("keydown", this.handleBindKey, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleBindKey, false);
    }
    handleBindKey = e => {
        handleHotKey.call(this, e);
    };
    render() {
        return <NCModal {...this.props}>{this.props.children}</NCModal>;
    }
}
export default HotKeyNCModal;
